import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["name", "children", "onClick"];
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import { kebabCase } from 'lodash';
const PagingHeaderSortLink = _ref => {
  let name = _ref.name,
    children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  const handleClick = e => onClick(name, e);
  return /*#__PURE__*/React.createElement(Button, _extends({
    color: "link",
    className: "t-phsl-".concat(kebabCase(name), " btn-link"),
    onClick: handleClick,
    tabIndex: 0,
    onKeyPress: handleClick
  }, props), children);
};
PagingHeaderSortLink.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default PagingHeaderSortLink;